import { Book } from 'lucide-react';

import { ReactComponent as NextJSIcon } from 'assets/icons/brands/nextjs.svg';
import { ReactComponent as LovableIcon } from 'assets/icons/brands/lovable.svg';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from 'components/ui/card';

import { ProjectCard } from './ProjectCard';

const PROJECTS = [
  {
    title: 'API Documentation',
    description: 'Explore the full Rye API reference',
    url: 'https://docs.rye.com',
    icon: Book,
  },
  {
    title: 'Next.js AI Shopping Assistant',
    description: 'Next.js AI chatbot using Rye to add ecommerce',
    url: 'https://github.com/cjavdev/rye-ai-chatbot',
    icon: NextJSIcon,
  },
  {
    title: 'Lovable Demo Store',
    description: 'Demo ecommerce app built with Lovable and Rye',
    url: 'https://github.com/rye-com/rye-lovable-demo',
    icon: LovableIcon,
  },
] as const;

export const ExploreSection = () => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Explore</CardTitle>
        <CardDescription>
          Dive deeper with API docs and ready-to-use starter projects.
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="grid auto-rows-fr grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
          {PROJECTS.map((project) => (
            <ProjectCard key={project.title} {...project} />
          ))}
        </div>
      </CardContent>
    </Card>
  );
};
